declare global {
  interface Window {
    MathJax: any;
  }
}
let init = false;
window.MathJax = window.MathJax || {};
if (!init) {
  window.MathJax.Hub.signal.Interest(function (message) {
    globalThis?.$logger?.info('mathjax Hub ::' + message);
  });
  init = true;
}

export const convertMathJax = (elt, onRenderComplete = null) => {
  if (!window.MathJax && !window.MathJax.isReady) {
    // wait for mathjax
    requestAnimationFrame(() => {
      return convertMathJax(elt, onRenderComplete);
    });
  }
  elt.classList.add('nmd-mathjax-rendering');
  window.MathJax.Hub.Queue(['Typeset', window.MathJax.Hub, elt], (status) => {
    elt.classList.add('nmd-mathjax-rendering-completed');
    if (onRenderComplete) onRenderComplete(elt);
  });
};
